import React, { useState, useEffect, useCallback } from "react";
import { LoadPanel } from "devextreme-react";
import { ToastDisplayer } from "../toastDisplay/ToastDisplayer";
import {
  getNotificationApi,
  UpdateNotificationStatusApi,
} from "../../api/notificationApi";
import { useAuth } from "../../contexts/auth";
import CustomEmpty from "../customEmptyView/CustomEmpty";
import { useNavigate } from "react-router-dom";

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
};

const NotificationItems = ({ refreshKey }) => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hoveredText, setHoveredText] = useState("");
  const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0 });

  const { user, setUnreadCount } = useAuth();
  const navigate = useNavigate();

  const showNotification = useCallback(async () => {
    if (!user?.companytransid && !user?.customertransid) {
      setNotifications([]);
      setUnreadCount(0);
      return;
    }

    try {
      setLoading(true);
      const response = await getNotificationApi(
        user?.companytransid,
        user?.customertransid,
      );

      const unreadNotifications = (response.data || []).filter(
        (n) => n.notificationstatus !== "read",
      );

      setNotifications(unreadNotifications);
      setUnreadCount(unreadNotifications.length);
    } catch (error) {
      console.error("Error fetching notifications:", error);
      setUnreadCount(0); //Don't leave stale count on error
    } finally {
      setLoading(false);
    }
  }, [user?.companytransid, user?.customertransid, setUnreadCount]);

  //useEffect AFTER the function it depends on
  useEffect(() => {
    if (refreshKey > 0) {
      // Clear All was triggered
      setNotifications([]);
      setUnreadCount(0);
      return;
    }
    showNotification();
  }, [refreshKey, showNotification]);

  const handleNotificationRead = async (transid) => {
    try {
      setLoading(true);
      await UpdateNotificationStatusApi({
        transid,
        notificationstatus: "read",
      });
      await showNotification();
    } catch (error) {
      ToastDisplayer("error", "Failed to update notification.");
    } finally {
      setLoading(false);
    }
  };

  const handleNavigateToTicket = (notification) => {
    if (!notification.ticketcode) return;
    navigate("/ticket/Details-of-Ticket", {
      state: { detailData: { ticketcode: notification.ticketcode } },
    });
  };

  return (
    <>
      {loading && <LoadPanel visible={loading} />}
      <div className="notification-main-container">
        {!Array.isArray(notifications) || notifications.length === 0 ? (
          <CustomEmpty moduleName="Notifications" />
        ) : (
          notifications.map((notification, index) => (
            <div
              key={index}
              className="notification-container"
              onClick={() => handleNavigateToTicket(notification)}
            >
              <div className="notification-header">
                <div className="notification-header-row">
                  <div className="notification-name">{notification.title}</div>
                  <div className="notification-header-right">
                    <span className="ticket-code">
                      {notification.ticketcode}
                    </span>
                    <i
                      className="ri-close-line notification-close-icon"
                      title="Mark as read"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleNotificationRead(notification.transid);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div
                className="notification-description"
                onMouseEnter={(e) => {
                  const rect = e.currentTarget.getBoundingClientRect();
                  setHoveredText(notification.description);
                  setTooltipPos({ x: rect.left, y: rect.bottom + 8 });
                }}
                onMouseLeave={() => setHoveredText("")}
              >
                {notification.description}
              </div>
              <div className="notification-createdby">
                By: {notification.createdby}
              </div>
              <div className="notification-subheader">
                <div className="notification-date">
                  {formatDate(notification.entrydate)}
                </div>
              </div>
            </div>
          ))
        )}
        {/* {hoveredText && (
          <div
            className="custom-tooltip"
            style={{
              top: 200,
              right: 200,
            }}
          >
            {hoveredText}
          </div>
        )} */}
      </div>
    </>
  );
};

export default NotificationItems;
